import { EditProjectForm } from "Projects/components";

function ProjectDetailsSettingsTab({ project }) {
  return <EditProjectForm initialValues={project} />;
}

export default ProjectDetailsSettingsTab;
